<span matDialogTitle>{{ data.title }}</span>
<mat-dialog-content>
  <p [innerHTML]="data.message" class="simple-dialog-message"></p>
  @if (data.inputType) {
    <form (ngSubmit)="submit(true)">
      <mat-form-field style="width: 100%;">
        <input [(ngModel)]="input" [type]="data.inputType" matInput name="input" required>
      </mat-form-field>
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.cancel) {
    <button (click)="submit(false)" mat-stroked-button type="button">
      {{ data.cancel }}
    </button>
  }
  <button (click)="submit(true)" mat-flat-button type="button">
    {{ data.ok }}
  </button>
</mat-dialog-actions>
